import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react";

import EventViewStore from "@state/stores/offer/event/EventViewStore";
import { AdditionalOfferViewStore } from "@state/stores/offer/shared/AdditionalOfferViewStore";
import { EventBodyTabs } from "@data-types/offer/event/EventViewStoreEnums";

import { EventContentToggleButton } from ".";

export default observer(function StatisticsToggleButton(props: {
	store: EventViewStore | AdditionalOfferViewStore;
	isDisabled?: boolean;
}) {
	const { t } = useTranslation();

	return (
		<EventContentToggleButton
			title={t("STATISTICS.TITLE")}
			isActive={props.store.currentTab === EventBodyTabs.Statistics}
			onClick={() => {
				if (!props.isDisabled) {
					props.store.openTab(EventBodyTabs.Statistics);
				}
			}}
			isDisabled={props.isDisabled}
		/>
	);
});
